<div class="header">
  <muni-gameday-card-header
    [entity]="entity | async"
    [orderCount]="(entityOrders | async)?.length"
    [amount]="(cardSource | async)?.amount"
    [isLinkClickable]="isLinkClickable | async"
    data-automation-e2e-selector="entityCardHeader"
  >
  </muni-gameday-card-header>
</div>
<div class="entityDetails">
  <div class="orders">
    <div class="component">
      <span
        class="empty"
        [hidden]="!(emptyMessage | async)"
        [textContent]="emptyMessage | async"
        data-automation-e2e-selector="entityOrdersEmptyMessagePlaceholder"
      >
      </span>
      <div [hidden]="emptyMessage | async" class="tableWrapper">
        <ag-grid-angular [theme]="'legacy'"
          class="ag-theme-cupcake entity-orders-grid"
          [gridOptions]="gridOptions"
          (sortChanged)="preserveCustomSorting($event)"
          (gridReady)="onGridReady($event)"
          (gridSizeChanged)="onGridSizeChanged($event)"
        >
        </ag-grid-angular>
      </div>
    </div>
  </div>
</div>
